import React, { useState } from 'react';
import styled from 'styled-components';

import Text from '../Text';
import BasicAccordion from './BasicAccordion';
import HTMLWrapper from '../HTMLWrapper';

import theme from '@theme';
import getScreenshotContent from '../helper-functions/getScreenshotContent';

const {
	font,
	colors,
	breakPoints: { mobileFirstScreenQuery },
} = theme;

const OverflowGrid = styled.div`
	display: grid;
	gap: 30px;
	width: 90%;
	margin: 0 auto;
	padding: 60px 0;

	${mobileFirstScreenQuery.large} {
		grid-template-columns: 50% 1fr; /* Two equal columns */
		gap: 47px; /* Space between the columns */
		box-sizing: border-box;
		padding: 144px 0;
	}

	${mobileFirstScreenQuery.extraLarge} {
		grid-template-columns: 1fr 1fr; /* Two equal columns */
		width: 100%;
	}
`;

const OverflowTextCell = styled.div`
	order: 2;

	h3 {
		font-family: ${font.semiBold};
		font-size: 20px;
		line-height: 28px; /* 140% */
		letter-spacing: 0.4px;
	}

	.screenshot__header {
		margin-bottom: 30px;
	}

	.accordion__content-text {
		padding: 0;
		font-size: 16px;
		line-height: 24px; /* 150% */
		letter-spacing: 0.16px;
	}

	.accordion__item {
		box-shadow: none;
		padding: 32px 55px;
		transition: all 0.75s ease-in-out;
	}

	.accordion__item[data-state='open'] {
		box-shadow: 0px 8px 48px 0px rgba(46, 64, 100, 0.15);
		border-bottom: 1px solid transparent;
	}

	.accordion__content {
		transition: all 0.75s linear;
	}
	${mobileFirstScreenQuery.large} {
		order: 1;
		padding-left: 40px;
	}

	@media screen and (min-width: 1300px) {
		margin-left: calc(100% - (1110px / 2));
		padding-left: 0;
	}
`;

const OverflowImageCell = styled.div`
	background: ${({ backgroundColor }) => backgroundColor};
	display: flex;
	order: 1;
	transition: background 0.75s ease-in-out;

	img {
		width: 100%;
	}

	${mobileFirstScreenQuery.large} {
		background-color: ${colors.secondary.main};
		order: 2;

		position: relative;
		overflow: hidden;
		height: ${({ screenshotArea }) => screenshotArea && screenshotArea + 'px'};

		img {
			width: 100%;
			height: 100%;
			object-fit: contain;
			object-position: center;
			transform: translate(10%, 0);
		}
	}
`;

const OverflowScreenshotAccordion = ({
	headingSize,
	screenshotArea,
	content,
	className,
}) => {
	const screenshotContent = getScreenshotContent(content);
	const [screenshotValue, setScreenshotValue] = useState('item-0');

	const screeshotIndex = Number(screenshotValue.split('-')[1]);

	const screenshots = [
		content.screenshot1.file.url,
		content.screenshot2.file.url,
		content.screenshot3.file.url,
		content?.screenshot4?.file.url,
		content?.screenshot5?.file.url,
	];

	return (
		<OverflowGrid gridGap="0px" className={className}>
			<OverflowTextCell spanLg={6} span={6}>
				<div className="screenshot__header">
					<Text component={`${headingSize ? headingSize : 'h2'}`}>
						{content.screenshotSectionHeader}
					</Text>
					<Text component="b2">
						<HTMLWrapper
							html={
								content.screenshotSectionDescription.childMarkdownRemark.html
							}
						/>
					</Text>
				</div>
				<BasicAccordion
					headerPadding="0 0 5px 0"
					questionSet={screenshotContent}
					defaultFirstOpen
					openItem={screenshotValue}
					setOpenItem={setScreenshotValue}
				/>
			</OverflowTextCell>
			<OverflowImageCell
				spanLg={6}
				span={6}
				screenshotArea={screenshotArea}
				backgroundColor={colors.screenshotBg[screeshotIndex]}
			>
				<img src={screenshots[screeshotIndex]} alt="Decorative" />
			</OverflowImageCell>
		</OverflowGrid>
	);
};

export default OverflowScreenshotAccordion;
